import React from 'react'
import SaleInvoicingCompletedInvoicesPage from './SaleInvoicePaidInvoicesPage';
import SaleInvoicingUnpaidInvoicesPage from './SaleInvoicingUnpaidInvoicesPage';
import SaleInvoicingUnprocessedSalesPage from './SaleInvoicingUnprocessedSalesPage';
import { AgTechTabPageProps } from '@agtech/web/components/Pages/Tabbed/AgTechTabPage';
import AgTechBadgedTabPage from '@agtech/web/components/Pages/Tabbed/Flavors/AgTechBadgeTabPage';

const SaleInvoicingOverviewPage = () => {
    return (
        <AgTechBadgedTabPage
            tabs={[
                {
                    text: "Unprocessed Sales",
                    content: () => <SaleInvoicingUnprocessedSalesPage />
                },
                {
                    text: "Unpaid Invoices",
                    content: () => <SaleInvoicingUnpaidInvoicesPage />
                },
                {
                    text: "Paid Invoices",
                    content: () => <SaleInvoicingCompletedInvoicesPage />
                }
            ]}
        />
    )
}

export default SaleInvoicingOverviewPage;